import React from 'react';
import { arrayOf, bool, shape } from 'prop-types';

// Components
import { Box, Typography } from '@mui/material';

// Utils
import { formatVolume } from 'utils/helpers/format';

const UsageChartTooltip = props => {
  const { active, payload } = props;

  if (active && payload?.length) {
    return (
      <Box
        alignItems="center"
        bgcolor="text.secondary"
        borderRadius="4px"
        display="flex"
        justifyContent="center"
        px={2}
        py={0.5}
      >
        <Typography sx={{ color: 'surface.white', fontWeight: 100 }} variant="caption">
          {formatVolume(payload[0].value)}
        </Typography>
      </Box>
    );
  }
  return null;
};

UsageChartTooltip.propTypes = {
  active: bool,
  payload: arrayOf(shape({})),
};

UsageChartTooltip.defaultProps = {
  active: null,
  payload: null,
};

export default UsageChartTooltip;
